module.exports = __webpack_public_path__ + "static/media/classifier.bc8bb85f.svg";